/** @format */

import NextLink from 'next/link';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface LinkProps {
  href: string;
  children: ReactNode;
  disabled?: boolean;
}

const StyledLink = styled(NextLink)`
  text-decoration: none;
  color: unset;
`;

function Link(props: LinkProps) {
  return (
    <StyledLink href={props.href} style={{ pointerEvents: props.disabled ? 'none' : 'auto' }}>
      {props.children}
    </StyledLink>
  );
}

export default Link;
